<template>
  <div class="dialog preview-experience">
    <div class="dialog__container">
      <div class="dialog__title">Preview Experiences</div>
      <div class="dialog__body">
        <div ref="carousel" class="space">
          <div
            v-for="item in spaces"
            :key="`spaces-item-${item.id}`"
            class="space__item"
            :class="{ 'space__item--active': currentSpaceItem.id === item.id }"
          >
            <button
              type="button"
              class="space__button"
              @click="handleClickSpaceItem(item)"
            >
              {{ item.name }}
            </button>
          </div>
        </div>
        <div
          class="preview-experience__content space__content"
          :class="`space__content--${currentSpaceItem.class}`"
          :style="{ visibility: imageLoaded ? 'visible' : 'hidden' }"
        >
          <img
            :src="`/theme/rbFront/img/w/mediaArtSolution/space/${currentSpaceItem.imageUrl}`"
            class="preview-experience__media preview-experience__media--desktop"
            @load="handleImageLoad"
          />
          <img
            :src="`/theme/rbFront/img/w/mediaArtSolution/space/${currentSpaceItem.imageMUrl}`"
            class="preview-experience__media preview-experience__media--mobile"
            @load="handleImageLoad"
          />
          <div
            class="preview-experience__video-container space__video-container"
          >
            <video
              ref="video"
              autoplay
              loop
              muted
              playsinline
              :src="`/theme/rbFront/img/w/mediaArtSolution/video/${currentReferenceListItem.video}`"
              class="preview-experience__video"
            />
          </div>
        </div>
        <button
          type="button"
          class="dialog__close"
          @click="dialogPreviewExperienceClose"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    spaces: {
      type: Array,
      required: true,
    },
    currentSpaceItem: {
      type: Object,
      required: true,
    },
    currentReferenceListItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      imageLoaded: false,
      slickInitialized: false,
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.initSlick()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    this.destroySlick()
  },
  methods: {
    dialogPreviewExperienceClose() {
      this.$emit('close')
    },
    handleClickSpaceItem(item) {
      if (this.currentSpaceItem.id === item.id) return
      this.imageLoaded = false
      this.$emit('click-space-item', item)
    },
    handleImageLoad() {
      setTimeout(() => {
        this.imageLoaded = true
      }, 1)
    },
    /* eslint-disable no-undef */
    initSlick() {
      if (window.innerWidth <= 1080 && !this.slickInitialized) {
        const $carousel = $(this.$refs.carousel)
        $carousel.slick({
          dots: false,
          infinite: false,
          speed: 300,
          variableWidth: true,
          arrows: false,
          touchThreshold: 100,
          swipe: true,
          slidesToScroll: 4,
        })
        this.slickInitialized = true
      }
    },
    /* eslint-disable no-undef */
    destroySlick() {
      if (this.slickInitialized) {
        $(this.$refs.carousel).slick('unslick')
        this.slickInitialized = false
      }
    },
    handleResize() {
      if (window.innerWidth <= 1080) {
        this.initSlick()
      } else {
        this.destroySlick()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@function p2w($px, $contaner: 312) {
  @return ($px / $contaner) * 100%;
}
@function p2h($px, $contaner: 208) {
  @return ($px / $contaner) * 100%;
}
$space: '.space';
#{$space} {
  display: flex;
  gap: 24px;
  padding: 0 20px;
  ::v-deep .slick-slide {
    margin-left: 16px;
  }
  &__item {
    color: #999;
    font-size: 16px;
    font-family: 'LG EI Text';
    padding-bottom: 12px;
    &--active {
      color: #ea1917;
      border-bottom: solid 2px #ea1917;
      font-weight: 600;
    }
  }
  &__button {
    color: inherit;
  }
  &__content {
    &--lobby {
      #{$space}__video-container {
        width: 636px;
        height: 359px;
        left: 172px;
        top: 124px;
        @media screen and (max-width: 1080px) {
          width: p2w(220);
          height: p2h(124);
          left: p2w(43);
          top: p2h(42);
        }
      }
    }
    &--hotel {
      #{$space}__video-container {
        width: 617px;
        height: 347px;
        left: 189px;
        top: 108px;
        @media screen and (max-width: 1080px) {
          width: p2w(213);
          height: p2h(120);
          left: p2w(49);
          top: p2h(37);
        }
      }
    }
    &--shopping-mall {
      #{$space}__video-container {
        width: 442px;
        height: 250px;
        left: 269px;
        top: 164px;
        @media screen and (max-width: 1080px) {
          width: p2w(152);
          height: p2h(86);
          left: p2w(77);
          top: p2h(56);
        }
      }
    }
    &--public-space {
      #{$space}__video-container {
        width: 524px;
        height: 296px;
        left: 223px;
        top: 134px;
        @media screen and (max-width: 1080px) {
          width: p2w(181);
          height: p2h(103);
          left: p2w(61);
          top: p2h(46);
        }
      }
    }
    &--media-facade {
      #{$space}__video-container {
        width: 659px;
        height: 370px;
        left: 164px;
        top: 87px;
        @media screen and (max-width: 1080px) {
          width: p2w(231);
          height: p2h(130);
          left: p2w(38);
          top: p2h(27);
        }
      }
    }
  }
  @media screen and (max-width: 1080px) {
    padding: 0 4px;
    &__item {
      padding-bottom: 6px;
    }
  }
}
.preview-experience {
  &__content {
    font-size: 0;
    position: relative;
    visibility: hidden;
  }
  &__media {
    width: 100%;
    height: auto;
    border-radius: 32px;
    &--desktop {
      display: block;
    }
    &--mobile {
      display: none;
    }
  }
  &__video-container {
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    background-color: #fff;
  }
  &__video {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transform: translate(-50%, -50%);
  }
  .dialog__title {
    text-transform: capitalize;
  }
  @media screen and (max-width: 1080px) {
    .dialog__title {
      width: 190px;
      line-height: 26.4px;
    }
    .dialog__body {
      gap: 16px;
    }
    &__media {
      &--desktop {
        display: none;
      }
      &--mobile {
        display: block;
      }
    }
  }
}
</style>
